import { Box, Typography } from '@mui/material';
import { PaymentWithTransfers } from '../../../../types/payments';
import PaymentTableRow from './PaymentTableRow';

interface Props {
  transactions: PaymentWithTransfers[];
  timezone: string;
  onSelectPayment: (payment: PaymentWithTransfers) => void;
}

function PaymentsTable({ transactions, timezone, onSelectPayment }: Props) {
  return (
    <Box>
      <Typography
        variant="body2"
        sx={{ color: 'text.secondary', margin: '28px 0 4px' }}>
        Transactions
      </Typography>
      {transactions.map(transaction => (
        <PaymentTableRow
          key={transaction.id}
          payment={transaction}
          timezone={timezone}
          onSelect={onSelectPayment}
        />
      ))}
    </Box>
  );
}

export default PaymentsTable;
